import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import PropTypes from 'prop-types';
import { Bar } from 'react-chartjs-2';
import { getAnalyticsSeriesColors, getSemanticSeriesColor, withAlpha } from './analyticsColors';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

export function BarChart({ chartData, title, label, showTitle = true, paletteVariant = 'default' }) {
  //const data = processData(chartData)//setChartData(chartData);
  const normalizedLabels = chartData[0].y.map((i) => i.replace('<br> ', '').replace('<br> ', '').replace('<br> ', ''));

  const data = {
    labels: normalizedLabels, //temporary fix for <br> in chart.js change later backend wise
    datasets: [
      {
        label: label ? label : `#of ${title}`,
        data: chartData[0].x,
        backgroundColor: normalizedLabels.map((labelValue, index) => {
          const semanticColor = getSemanticSeriesColor(labelValue);
          return semanticColor
            ? withAlpha(semanticColor, 0.24)
            : getAnalyticsSeriesColors(index, { variant: paletteVariant, label: labelValue }).background;
        }),
        borderColor: normalizedLabels.map((labelValue, index) => {
          const semanticColor = getSemanticSeriesColor(labelValue);
          return (
            semanticColor || getAnalyticsSeriesColors(index, { variant: paletteVariant, label: labelValue }).border
          );
        }),
        borderWidth: 1,
        borderRadius: 6,
        hoverBackgroundColor: normalizedLabels.map((labelValue, index) => {
          const semanticColor = getSemanticSeriesColor(labelValue);
          return semanticColor
            ? withAlpha(semanticColor, 0.44)
            : getAnalyticsSeriesColors(index, { variant: paletteVariant, label: labelValue }).hover;
        }),
      },
    ],
  };
  const options = {
    responsive: true,

    plugins: {
      title: {
        display: showTitle,
        text: `${title}`,
      },
    },
    indexAxis: 'y', //set in case of horizontal bar chart
    maintainAspectRatio: false,
  };

  return <Bar options={options} data={data} />;
}

BarChart.propTypes = {
  chartData: PropTypes.array,
  title: PropTypes.string,
  label: PropTypes.string,
  showTitle: PropTypes.bool,
  paletteVariant: PropTypes.string,
};
